import { render, staticRenderFns } from "./CompliantForm.vue?vue&type=template&id=5bcb4c7c&"
import script from "./CompliantForm.vue?vue&type=script&lang=js&"
export * from "./CompliantForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports